// extracted by mini-css-extract-plugin
export var align_center = "contentWithImage-module--align_center--f975b";
export var align_top = "contentWithImage-module--align_top--9c9c0";
export var content = "contentWithImage-module--content--b8f9b";
export var image = "contentWithImage-module--image--b6b68";
export var textOnRight = "contentWithImage-module--textOnRight--87b45";
export var textWidth_33 = "contentWithImage-module--textWidth_33--18d38";
export var textWidth_50 = "contentWithImage-module--textWidth_50--6e945";
export var textWidth_66 = "contentWithImage-module--textWidth_66--e3b3e";
export var textWidth_75 = "contentWithImage-module--textWidth_75--1dd81";
export var wrapper = "contentWithImage-module--wrapper--3558f";